document.addEventListener('DOMContentLoaded', function() {
    // Znajdź wszystkie linki wewnątrz summary
    const menuLinks = document.querySelectorAll('.menu-with-link .header__menu-item-link');
    
    // Dla każdego linku
    menuLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        // Nie zatrzymuj propagacji - pozwól linkowi działać
        e.stopPropagation();
      });
    });
    
    // Znajdź wszystkie ikony strzałek
    const caretIcons = document.querySelectorAll('.menu-with-link .caret-icon');
    
    // Dla każdej ikony strzałki
    caretIcons.forEach(caret => {
      caret.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Znajdź nadrzędny element details
        const details = this.closest('details');
        
        // Przełącz stan details
        if (details) {
          details.open = !details.open;
        }
      });
    });
  });